import React, { useState } from 'react';
import { Button, message } from 'antd';
import api from '../../services/api';
import ProcessSubmitPreviewModal from './ProcessSubmitPreviewModal';

function ProcessDraftSubmitAction({
  processId,
  bizType = 'hr_process',
  loading: externalLoading,
  onSuccess
}) {
  const [loading, setLoading] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [wfStepAssignees, setWfStepAssignees] = useState({});
  const busy = loading || externalLoading;

  const handleOpenPreview = async () => {
    try {
      setLoading(true);
      const res = await api.post(`/approval-center/drafts/${processId}/preview`, {
        wf_step_assignees: wfStepAssignees
      }, {
        params: { biz_type: bizType }
      });
      if (res.data.success) {
        setPreviewData(res.data.data);
        setPreviewVisible(true);
      }
    } catch (e) {
      message.error(e.response?.data?.message || '预览失败');
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmSubmit = async (pickedAssignees = wfStepAssignees) => {
    try {
      setLoading(true);
      await api.post(`/approval-center/drafts/${processId}/submit`, {
        wf_step_assignees: pickedAssignees
      }, {
        params: { biz_type: bizType }
      });
      message.success('流程已提交');
      setPreviewVisible(false);
      setPreviewData(null);
      setWfStepAssignees({});
      onSuccess?.();
    } catch (e) {
      message.error(e.response?.data?.message || '提交失败');
    } finally {
      setLoading(false);
    }
  };

  const initiatorSelectSteps = previewData?.workflow?.initiator_select_steps || [];

  return (
    <>
      <div className="process-detail-actions">
        <Button type="primary" loading={busy} onClick={handleOpenPreview}>
          提交审批
        </Button>
      </div>
      <ProcessSubmitPreviewModal
        open={previewVisible}
        previewProcess={previewData ? {
          ...previewData,
          status: 'draft',
          workflow: previewData.workflow,
          applicant_name: previewData.applicant_name
        } : null}
        confirmLoading={busy}
        initiatorSelectSteps={initiatorSelectSteps}
        wfStepAssignees={wfStepAssignees}
        onWfStepAssigneesChange={setWfStepAssignees}
        onCancel={() => {
          setPreviewVisible(false);
          setPreviewData(null);
          setWfStepAssignees({});
        }}
        onConfirm={handleConfirmSubmit}
      />
    </>
  );
}

export default ProcessDraftSubmitAction;
